<!--Copy right - © 2024 tecera gmbh-->
<script>
    import {
        is_authenticated,
        check_if_authenticated,
        user_permissions,
        rerout_user,
    } from "../scripts/auth.js";
    import { onMount, onDestroy } from "svelte";
    import {
        free_hymos,
        all_hymos,
        selected_device,
        map_center,
        is_modal_open,
        modal_mode,
        current_device_data,
        last_meta_data,
        extended_device_channel_list,
        hymo_alarms_triggered_new,
        hymo_alarms_triggered_old,
        hymo_data_end_date,
    } from "../stores.js";
    import NavBar from "../components/NavBar.svelte";
    import Footer from "../components/Footer.svelte";
    import MessgroesseButton from "../components/buttons/MessgroesseButton.svelte";
    import SwitchButton from "../components/buttons/SwitchButton.svelte";
    import SignalDisplay from "../components/SignalDisplay.svelte";
    import StreetMap from "../components/StreetMap.svelte";
    import HymoGraph from "../components/HymoGraph.svelte";
    import NeuesGeraetButton from "../components/buttons/NeuesGeraetButton.svelte";
    import NeuesGeraetModal from "../components/modals/NeuesGeraetModal.svelte";
    import DeviceButton from "../components/buttons/DeviceButton.svelte";
    import Meldungen from "../components/Meldungen.svelte";
    import MeldungenEntry from "../components/MeldungenEntry.svelte";
    import DeviceSearchField from "../components/DeviceSearchField.svelte";
    import DataTabelleNew from "../components/DataTabelleNew.svelte";
    import GrenzwerteDeviceButton from "../components/buttons/GrenzwerteDeviceButton.svelte";
    import AlarmAuswahl from "../components/AlarmAuswahl.svelte";
    import DatePicker from "../components/DatePicker.svelte";
    import SegmentControl2 from "../components/SegmentControl2.svelte";
    import DownloadButton from "../components/buttons/DownloadButton.svelte";
    import AlarmKreisModal from "../components/modals/AlarmKreisModal.svelte";
    import { fade } from "svelte/transition";
    import {
        get_free_hymos,
        get_hymo_configs,
        get_alarms_current_hymo,
        get_alarms_old_hymo,
        get_hymo_data,
        create_extended_channel_list,
    } from "../scripts/data.js";
    import {
        ALARM_REFRESH_INTERVALL_IN_SECONDS,
        DATA_REFRESH_INTERVALL_IN_SECONDS,
        ENABLE_LIVE_RELOADING,
    } from "../config.js";
    import CsvDownloadModal from "../components/modals/CsvDownloadModal.svelte";

    let show_loaders = false;
    let show_old_alarms = false;
    let headline = "Trinkwasser-Netzdaten";
    let device_search_input = "";
    let init_alarm_fetch = true;
    let alarm_fetch_interval, data_fetch_interval;
    let show_data_table = false;
    let is_mounted = false;
    let chart_data;
    let is_alarmierungskreis_modal_open = false;
    let is_csv_download_modal_open = false;
    let data_promise;
    let is_disabled = false;
    let chosen_segment = "Druck";
    const HYMO_GROUP = "drinking_water";

    var end_date = moment(); // Now
    var start_date = moment().subtract(1, "weeks"); // Two weeks ago

    onMount(async () => {
        is_mounted = true;
        $selected_device = null; // need to set this to null incase user comes from different tab
        await check_if_authenticated(); // waiting for auth before proceeding
        data_promise = new Promise((resolve) => {
            setTimeout(() => {
                resolve("Fake data for loader");
            }, 500);
        });
        if (
            !$user_permissions["access_drinking_water"] || //TODO: check if this is correct
            $user_permissions["access_drinking_water"] != 1
        ) {
            rerout_user();
            return;
        }
        fetch_hymo_configs();
        get_alarms();
        get_free_hymos(HYMO_GROUP); // can be used as a promise
        if (ENABLE_LIVE_RELOADING) {
            alarm_fetch_interval = setInterval(
                get_alarms,
                ALARM_REFRESH_INTERVALL_IN_SECONDS * 1000,
            );
            data_fetch_interval = setInterval(
                refresh_hymo_data,
                DATA_REFRESH_INTERVALL_IN_SECONDS * 1000,
            );
        }
    });

    // fetch all hymo configs and change loader state
    async function fetch_hymo_configs() {
        show_loaders = true;
        await get_hymo_configs(HYMO_GROUP);
        $selected_device = $all_hymos[0];
        show_loaders = false;
    }

    async function get_alarms() {
        await get_alarms_current_hymo("drinking_water");
        init_alarm_fetch = false;
        await get_alarms_old_hymo("drinking_water");
    }

    async function refresh_hymo_data() {
        if (
            moment().diff(end_date) / 1000 <
            DATA_REFRESH_INTERVALL_IN_SECONDS * 4
        ) {
            end_date = moment();
        }
        if (
            $selected_device &&
            $all_hymos.some((hymo) => hymo.id === $selected_device.id)
        ) {
            // added .some check so wrong device type can't be selected
            get_hymo_data($selected_device.id, start_date, end_date);
        }
    }

    onDestroy(() => {
        clearInterval(alarm_fetch_interval);
        clearInterval(data_fetch_interval);
        $all_hymos = [];
        $free_hymos = [];
        $hymo_alarms_triggered_new = [];
        $hymo_alarms_triggered_old = [];
        $selected_device = null;
        $current_device_data = [];
        $last_meta_data = null;
    });

    // reactive centering of the map on the selected device
    //TODO: add change of segment
    $: {
        if (
            $selected_device &&
            $all_hymos.some((hymo) => hymo.id === $selected_device.id)
        ) {
            select_device();
        }
    }

    function select_device() {
        // added .some check so wrong device type can't be selected
        reset_data();
        change_segment();
        data_promise = get_hymo_data($selected_device.id, start_date, end_date);
        create_extended_channel_list();
        map_center.set([$selected_device.latitude, $selected_device.longitude]);
    }

    function reset_data() {
        $current_device_data = [];
        $last_meta_data = null;
    }
    function toggle_table_view(bool) {
        show_data_table = bool;
    }
    function toggle_disable(bool) {
        is_disabled = bool;
    }
    function force_segment(segment) {
        if (chosen_segment == "Grenzwerte") {
            chosen_segment = "Grenzwerte";
        } else {
            chosen_segment = segment;
        }
    }

    function change_segment() {
        let changed_segment;
        if ($selected_device.sub_group == "temperature") {
            changed_segment = "Temperatur";
        } else if ($selected_device.sub_group == "pressure") {
            changed_segment = "Druck";
        } else if ($selected_device.sub_group == "volume_flow") {
            changed_segment = "Durchfluss";
        } else {
            changed_segment = "Grenzwerte";
        }
        force_segment(changed_segment);
    }

    $: {
        $hymo_data_end_date = end_date;
    }

    $: {
        if ($selected_device && start_date && end_date) {
            refresh_hymo_data();
        }
    }
</script>

<svelte:head>
    <title>Mapview - Trinkwasser-Netzdaten</title>
</svelte:head>

{#if $is_authenticated && $user_permissions["access_drinking_water"] == 1}
    <div class="container-fluid">
        <div class="row">
            <!-- Main Content -->
            <main class="col-12 ml-sm-auto px-md-4">
                <NavBar {headline} />
                <div class="row">
                    <!-- Linke Seite -->
                    <div
                        class="col-12 col-xl-9 col-lg-8 col-md-7 content_main"
                        style="display:flex;flex-direction:column;justify-content:flex-start;"
                    >
                        <div
                            class="row"
                            style="{show_data_table
                                ? "flex: 0 0 6%;"
                                : "flex: 1 1 59%;"}overflow:hidden;"
                        >
                            <div
                                class="col-xl-9 col-lg-7"
                                style="display:flex;flex-direction:column;justify-content:flex-start;"
                            >
                                <div class="row" style="flex: 0 1 5%;">
                                    <!-- Buttons -->
                                    <div
                                        class="col-9 col-lg-9 col-md-8 pl-3 pt-3 pr-0"
                                        style="align-items: flex-start;justify-content: flex-start;display:flex;flex: 1 1 60%;"
                                    >
                                        <div
                                            class="d-md-flex d-inline justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2"
                                        >
                                            <div class="btn-toolbar pb-1">
                                                <NeuesGeraetButton
                                                    label={"Neues Gerät"}
                                                    func={() => {
                                                        $modal_mode = "create";
                                                        $is_modal_open = true;
                                                    }}
                                                />
                                                <DatePicker
                                                    bind:start_date
                                                    bind:end_date
                                                />
                                                <MessgroesseButton
                                                    multiple_devices={false}
                                                    bind:chart_data
                                                />
                                                <SwitchButton
                                                    bind:toggle_state={show_data_table}
                                                    bind:is_disabled
                                                    label0="Tabelle"
                                                    label1="Diagramm"
                                                    icon_0="fa-table"
                                                    icon_1="fa-chart-line"
                                                />
                                                <DownloadButton
                                                    bind:modal_toggle={is_csv_download_modal_open}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Letzter Sendezeitraum und Signalstaerke -->
                                    <div
                                        class="col-3 col-lg-3 col-md-4 p-0 ml-0 pr-2 pt-3"
                                        style="align-items: flex-end;justify-content: flex-end;display:flex;flex: 1 0 150px;min-width:fit-content;"
                                    >
                                        <SignalDisplay />
                                    </div>
                                </div>

                                {#if !show_data_table}
                                    <!-- Map -->
                                    <div
                                        class="row"
                                        style="flex: 1 1 50%;min-height:200px;"
                                    >
                                        <div class="col-12 full">
                                            <StreetMap
                                                devices={all_hymos}
                                                alarms_triggered={hymo_alarms_triggered_new}
                                                multiple_devices={false}
                                            />
                                        </div>
                                    </div>
                                {/if}
                            </div>

                            {#if !show_data_table}
                                <!-- Meldungen -->
                                <div class="col-xl-3 col-lg-5 pt-4">
                                    <Meldungen bind:show_old_alarms>
                                        {#if init_alarm_fetch}
                                            <div
                                                id="loader_devices"
                                                class="loader"
                                            />
                                        {:else if show_old_alarms}
                                            {#each $hymo_alarms_triggered_old as alarm_triggered (alarm_triggered.id)}
                                                <MeldungenEntry
                                                    {alarm_triggered}
                                                    {show_old_alarms}
                                                    type="hymo"
                                                    alarm_list={hymo_alarms_triggered_old}
                                                />
                                            {/each}
                                        {:else}
                                            {#each $hymo_alarms_triggered_new as alarm_triggered (alarm_triggered.id)}
                                                <MeldungenEntry
                                                    {alarm_triggered}
                                                    {show_old_alarms}
                                                    type="hymo"
                                                    alarm_list={hymo_alarms_triggered_new}
                                                />
                                            {/each}
                                        {/if}
                                    </Meldungen>
                                </div>
                            {/if}
                        </div>

                        {#if show_data_table}
                            <div
                                class="row"
                                style="flex: 1 1 30%;overflow:hidden;"
                                in:fade={{ duration: 200 }}
                            >
                                <DataTabelleNew
                                    {is_mounted}
                                    bind:chart_data
                                    multiple_devices={false}
                                />
                            </div>
                        {:else}
                            <!-- Diagramm -->
                            <div class="row pt-4" style="flex: 1 1 30%;">
                                {#await data_promise}
                                    <div class="col-12 full">
                                        <div
                                            id="loader_devices"
                                            class="loader"
                                        />
                                    </div>
                                {:then}
                                    {#if $current_device_data && $current_device_data.length > 0}
                                        <div class="col-12 full">
                                            <HymoGraph />
                                        </div>
                                    {:else}
                                        <div
                                            class="col-12 full center-flex-box"
                                        >
                                            <p class="h1 p-kachel-2">
                                                Keine Daten im angegebenen
                                                Zeitraum verfügbar
                                            </p>
                                        </div>
                                    {/if}
                                {/await}
                            </div>
                        {/if}
                    </div>

                    <!-- Rechte Seite -->
                    <!-- Rechte Seite HyMo und Meldungen -->
                    <!-- Wird durch Grenzwert-Button deaktiviert/aktiviert -->

                    <div
                        class="col-12 col-xl-3 col-lg-4 col-md-5 content_main content_main_side"
                        style="display:flex;flex-direction:column;justify-content:flex-start;"
                    >
                        <!-- water meter Menü -->
                        <div class="row pt-4 full">
                            <div class="col-12 full">
                                <div
                                    class="display_box side-menu side-menu-scroll"
                                    style="position:relative;"
                                >
                                    <SegmentControl2
                                        bind:chosen_segment
                                        segments={[
                                            "Druck",
                                            "Temperatur",
                                            "Durchfluss",
                                            "Grenzwerte",
                                        ]}
                                    />

                                    {#if chosen_segment == "Temperatur"}
                                        <p class="p-kachel">Temperatur</p>

                                        <!-- Suchfeld -->
                                        <DeviceSearchField
                                            bind:device_search_input
                                        />

                                        <div
                                            id="hymoMenu"
                                            class="scroll_window"
                                        >
                                            {#if show_loaders}
                                                <div
                                                    id="loader_devices"
                                                    class="loader"
                                                />
                                            {:else}
                                                {#each $all_hymos as device_config (device_config.id)}
                                                    {#if device_config.sub_group == "temperature" && (!device_config.name || device_config.name
                                                                .toLowerCase()
                                                                .includes(device_search_input.toLowerCase()) || device_config.dev_eui
                                                                .toLowerCase()
                                                                .includes(device_search_input.toLowerCase()))}
                                                        <DeviceButton
                                                            {device_config}
                                                            multiple_devices={false}
                                                        />
                                                    {/if}
                                                {/each}
                                            {/if}
                                        </div>
                                    {:else if chosen_segment == "Druck"}
                                        <p class="p-kachel">Druck</p>

                                        <!-- Suchfeld -->
                                        <DeviceSearchField
                                            bind:device_search_input
                                        />

                                        <div
                                            id="hymoMenu"
                                            class="scroll_window"
                                        >
                                            {#if show_loaders}
                                                <div
                                                    id="loader_devices"
                                                    class="loader"
                                                />
                                            {:else}
                                                {#each $all_hymos as device_config (device_config.id)}
                                                    {#if device_config.sub_group == "pressure" && (!device_config.name || device_config.name
                                                                .toLowerCase()
                                                                .includes(device_search_input.toLowerCase()) || device_config.dev_eui
                                                                .toLowerCase()
                                                                .includes(device_search_input.toLowerCase()))}
                                                        <DeviceButton
                                                            {device_config}
                                                            multiple_devices={false}
                                                        />
                                                    {/if}
                                                {/each}
                                            {/if}
                                        </div>
                                    {:else if chosen_segment == "Durchfluss"}
                                        <p class="p-kachel">Durchfluss</p>

                                        <!-- Suchfeld -->
                                        <DeviceSearchField
                                            bind:device_search_input
                                        />

                                        <div
                                            id="hymoMenu"
                                            class="scroll_window"
                                        >
                                            {#if show_loaders}
                                                <div
                                                    id="loader_devices"
                                                    class="loader"
                                                />
                                            {:else}
                                                {#each $all_hymos as device_config (device_config.id)}
                                                    {#if device_config.sub_group == "volume_flow" && (!device_config.name || device_config.name
                                                                .toLowerCase()
                                                                .includes(device_search_input.toLowerCase()) || device_config.dev_eui
                                                                .toLowerCase()
                                                                .includes(device_search_input.toLowerCase()))}
                                                        <DeviceButton
                                                            {device_config}
                                                            multiple_devices={false}
                                                        />
                                                    {/if}
                                                {/each}
                                            {/if}
                                        </div>
                                    {:else if chosen_segment == "Grenzwerte"}
                                        <p class="p-kachel">Grenzwerte</p>
                                        <GrenzwerteDeviceButton
                                            device_list={all_hymos}
                                        />
                                        <div class="input-group mb-2 mt-4">
                                            <button
                                                id="show_alarmierungskreis"
                                                class="btn btn-primary btn-block"
                                                on:click={() => {
                                                    if(is_disabled){
                                                        return;
                                                    }
                                                    is_alarmierungskreis_modal_open = true;
                                                }}
                                            >
                                                Alarmierungskreis
                                            </button>
                                        </div>
                                        <div
                                            id="hymoMenu"
                                            class="scroll_window"
                                        >
                                            <AlarmAuswahl />
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>

    <NeuesGeraetModal bind:is_open={$is_modal_open} hymo_group={HYMO_GROUP}/>
    <CsvDownloadModal bind:is_open={is_csv_download_modal_open} multiple_devices={false}/>
    <AlarmKreisModal bind:is_open={is_alarmierungskreis_modal_open} />

    <Footer />
{/if}
